import { useEffect, useState } from "react";

const ANIMATION_DURATION = 2000;
const FINAL_OFFSET_X = -200;
const FINAL_SCALE = 3;

export const useScanningAnimation = () => {
  const [scanComplete, setScanComplete] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const windowHeight = getScreenHeight();
    if (!windowHeight) {
      return;
    }

    let offsetY = windowHeight * 0.8;
    if (windowHeight < 600) {
      offsetY = windowHeight * 0.4;
    } else if (windowHeight < 700) {
      offsetY = windowHeight * 0.65;
    }

    const zoomInterval = setInterval(() => {
      setZoomLevel((prev) => Math.min(prev + 0.5, FINAL_SCALE));
    }, 100);

    const moveInterval = setInterval(() => {
      setOffset((prev) => ({
        x: (Math.sin(Date.now() / 1000) * 20) + FINAL_OFFSET_X, // Oscillate between -20 and 20 pixels
        y: (Math.cos(Date.now() / 1500) * 20) + offsetY, // Smaller vertical movement
      }));
    }, 16); // ~60fps

    const timeout = setTimeout(() => {
      clearInterval(moveInterval);
      setOffset({ x: FINAL_OFFSET_X, y: offsetY }); // Final offset position
      setScanComplete(true);
    }, ANIMATION_DURATION);

    return () => {
      clearInterval(zoomInterval);
      clearInterval(moveInterval);
      clearTimeout(timeout);
    };
  }, []);

  return {
    zoomLevel,
    scanComplete,
    offset
  };
}

const getScreenHeight = () => window.screen.height ?? window.innerHeight ?? 0;